import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router'
import { MessageService } from 'primeng/api'
import { Observable, catchError, map, of, tap } from 'rxjs'
import {
  AppSettingService,
  AuthService,
  RolesService,
  UserPracticesService,
} from '../../api/services'
import { CareFinitySession } from './CareFinitySession'
import { CarefinityRoles } from '../../api/models'

@Injectable()
export class AuthGuard {
  role: CarefinityRoles

  constructor(
    private messageService: MessageService,
    private router: Router,
    private appSetting: AppSettingService,
    private authService: AuthService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let url: string = state.url
      this.role = CareFinitySession.user.roles;
     
    return this.checkUserLogin(next, url)
  }

  private checkUserLogin(
    route: ActivatedRouteSnapshot,
    path: any,
  ): Observable<boolean> {
  
      if (!this.checkPrivileges(path)) {
        //  alert("GGGGG");
          this.logout(path)
          return of(false)
      }
      return of(true);
       
  }

    private checkPrivileges(path: any): boolean

    {
       // alert("GGGGG");

    if (path?.indexOf('appointment') > -1 && this.role.appointment !== true) {
      return this.logout(path)
    } else if (
      path?.indexOf('global-config') > -1 &&
      this.role.manageGlobalConfig !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('practice-config') > -1 &&
      this.role.managePracticeConfig !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('user-list') > -1 &&
      this.role.manageUsers !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('patientsearch') > -1 &&
      this.role.patientSearch !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('users-practice') > -1 &&
      this.role.manageUserPractices !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('reset-password-group') > -1 &&
      this.role.resetAllPasswords !== true
    ) {
      return this.logout(path)
    }

    //else if (
    //  path?.indexOf('change-password') > -1 &&
    //  this.role.changePassword !== true
    //)

    //{
    //  return this.logout(path)
    //    }
       

    //else if (path?.indexOf('security-token') > -1 &&  this.role.emergencyToken !== true
    //) {
    //    alert(this.role.emergencyToken);
    //  return this.logout(path)
    //}

    //else if (path?.indexOf('patient-demographics') > -1 && this.role.patientDemographics !== true)
    //{
    //  alert(this.role.patientDemographics)
    //  return this.logout(path)
    //}

    else if (
      path?.indexOf('report-categories') > -1 &&
      this.role.manageReports !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('manage-reports') > -1 &&
      this.role.manageReports !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('manage-roles') > -1 &&
      this.role.manageRoles !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('manage-notes') > -1 &&
      this.role.manageNotes !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('patient-archive') > -1 &&
      this.role.patientArchive !== true
    ) {
      return this.logout(path)
    } else if (path?.indexOf('allergy') > -1 && this.role.allergies !== true) {
      return this.logout(path)
    } else if (path?.indexOf('problems') > -1 && this.role.problems !== true) {
      return this.logout(path)
    } else if (
      path?.indexOf('medication') > -1 &&
      this.role.medication !== true
    ) {
      return this.logout(path)
    } else if (path?.indexOf('visits') > -1 && this.role.visits !== true) {
      return this.logout(path)
    } else if (path?.indexOf('orders') > -1 && this.role.orders !== true) {
      return this.logout(path)
    } else if (path?.indexOf('images') > -1 && this.role.images !== true) {
      return this.logout(path)
    }
    else if ((path?.indexOf('documents/catlist') || path?.indexOf('documents/list')) > -1 && this.role.documents !== true)
    {
      return this.logout(path)
    }

    else if ((path?.indexOf('financial/details') || path?.indexOf('financial/details')) > -1 && this.role.financialSummary !== true) {
        return this.logout(path)
    }


    else if (path?.indexOf('listmapping') > -1 && this.role.manageGlobalSetting !== true) {
        return this.logout(path)
    }

    else if (path?.indexOf('ViewReports') > -1 && this.role.viewReports !== true) {
        return this.logout(path)
    }


    else if (path?.indexOf('labs') > -1 && this.role.labs !== true) {
      return this.logout(path)
    } else if (
      path?.indexOf('events') > -1 &&
      this.role.significantEvents !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('financial') > -1 &&
      this.role.financialSummary !== true
    ) {
      return this.logout(path)
    } else if (path?.indexOf('billing') > -1 && this.role.charge !== true) {
      return this.logout(path)
    } else if (path?.indexOf('vitals') > -1 && this.role.vitals !== true) {
      return this.logout(path)
    } else if (
      path?.indexOf('exportdocuments') > -1 &&
      this.role.exportdocuments !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('/Patient/notes/manage') > -1 &&
      this.role.notes !== true
    ) {
      return this.logout(path)
    } else if (
      path?.indexOf('manage-questions') > -1 &&
      this.role.securityQuestions !== true
    ) {
      return this.logout(path)
    }
    return true
  }

  private logout(path: string): boolean {
    console.log('user does not have access to resource')
    CareFinitySession.logout(this.authService)
    this.router.navigate(['/'], { queryParams: { returnUrl: path } })
    return false
  }
}
